"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyPolicyCertificate = void 0;
var PolicyCarData_1 = require("./PolicyCarData");
function makeEmptyPolicyCertificate() {
    return {
        certificateStatus: '',
        carData: PolicyCarData_1.makeEmptyPolicyCarData(),
    };
}
exports.makeEmptyPolicyCertificate = makeEmptyPolicyCertificate;
//# sourceMappingURL=PolicyCertificate.js.map